/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import Toast from 'react-native-toast-message';

import { showPopup } from '@/store/modal';
import { paramsReseted, isFiltered } from '@/store/params';

import { Container } from '@components/screen/Layout';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import Image from '@components/global/Image';
import Button from '@components/form/Button';
import ModalExport from '@components/customer/loyalty/ModalExport';
import MoreButton from '@components/navbar/MoreButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { buttonPrimary, buttonRounded } from '@/assets/styles/buttonStyles';
import { getSavedFilter } from '@global/helpers';
import tableApi from '@/hooks/tableApi';
import store from '@/store';
import { getCustomers, getCustomersCount } from '@api/ms-account';
import { exportLoyaltyPoint } from '@api/ms-b2b';

const HEADER_DEKSTOP = [
  {
    label: 'Customer Name',
    data: 'name',
    width: '50%',
  },
  {
    label: 'Loyalty Point',
    data: 'point',
    width: '50%',
    filter: {
      type: 'number',
      label: 'Point Amount',
      actions: [
        { value: '$lt', label: 'Less than' },
        { value: '$eq', label: 'Equal Amount' },
        { value: '$gt', label: 'More than' },
      ],
      actionType: 'radio',
      filter: 'loyalty_points.count',
    },
  },
];

let init = true;

function LoyaltyScreen(props) {
  const tableRef = useRef();
  const [list, setList] = useState([]);
  const [modalExport, setModalExport] = useState(false);

  const img = require('@/assets/img/default/user-image.png');

  const dispatch = useDispatch();

  const paramsState = useSelector((state) => state.params);
  const hasFilter = useSelector(isFiltered);

  const loyalty = tableApi(getCustomersCount, getCustomers);

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => callBackRowPress(item)}
      key={'list-brand-' + index}
      style={styles.tableRow}>
      <View style={{ width: '10%' }}>
        <Image
          style={{ width: 36, height: 36 }}
          width={36}
          height={36}
          isResolveAsset
          source={item.image ? { uri: item.image } : img}
        />
      </View>
      <SociollaText
        type="medium"
        style={{
          textAlign: 'left',
          fontSize: 16,
          color: Colors.black1,
          width: '60%',
          paddingLeft: 16,
        }}>
        {item.name}
      </SociollaText>
      <View style={{ width: '30%' }}>
        <SociollaText
          style={{
            color: Colors.black5,
            fontSize: 10,
            textAlign: 'right',
            marginBottom: 5,
          }}>
          Loyalty Points
        </SociollaText>
        <SociollaText
          type="medium"
          currency={true}
          style={{ color: Colors.blue3, fontSize: 16, textAlign: 'right' }}>
          {item.point}
        </SociollaText>
      </View>
    </TouchableOpacity>
  );

  const renderItemDekstop = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => callBackRowPress(item)}
      key={'list-brand-' + index}
      style={[
        styles.tableRowDekstop,
        { backgroundColor: index % 2 == 1 ? '#F7F7F7' : '#FFFFFF' },
      ]}>
      <View
        style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          width: '50%',
          paddingLeft: 20,
        }}>
        <Image
          style={{ width: 20, height: 20, marginRight: 12 }}
          width={20}
          height={20}
          source={item.image ? { uri: item.image } : img}
        />
        <SociollaText type="medium" style={{ alignSelf: 'center' }}>
          {item.name}
        </SociollaText>
      </View>
      <SociollaText
        style={[styles.columnRowTxt, { width: '50%' }]}
        currency={true}>
        {item.point}
      </SociollaText>
    </TouchableOpacity>
  );

  const generateData = (data) => {
    return (data || []).map((cus) => {
      return {
        ...cus,
        point: (cus.loyalty_points && cus.loyalty_points.count) || 0,
      };
    });
  };

  const callBackRowPress = (item) => {
    if (!item || !item._id) {
      return false;
    }
    props.navigation.navigate('LoyaltyDetailScreen', {
      id: item._id,
      name: item.name,
      tab: 'loyalty',
      prev_page: 'loyalty',
    });
  };

  const callback = (data) => {
    if (data.key === 'export') {
      setModalExport(true);
    } else if (data.key === 'filter') {
      dispatch(showPopup({ name: 'sociollaFilter', value: 'loyalty-screen' }));
    }
  };

  const exportLoyalty = (email) => {
    if (email) {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      exportLoyaltyPoint({
        email,
      })
        .then((res) => {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          if (res.status === 200) {
            Toast.show({
              text1: 'Successfully send to ' + email,
              type: 'success',
            });
            setModalExport(false);
          } else {
            Toast.show({
              text1: 'Something Wrong, please try again.',
              type: 'error',
            });
          }
        })
        .catch((e) => {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Something Wrong, please try again.',
            type: 'error',
          });
        });
    }
  };

  const fetchData = (filter) => {
    const params = JSON.parse(JSON.stringify(store.getState().params));
    params.sort = '-_id';
    let filtered = false;
    if (params.filter?.keyword) {
      filtered = true;
    } else {
      filtered = hasFilter;
    }
    if (props.route?.params?.isHome) {
      params.filter['status'] = 'approved';
    }
    loyalty.request(params, null, filtered).then((response) => {
      if (response) {
        setList(generateData(response));
        init = false;
      }
    });
  };

  useEffect(() => {
    if (!init) {
      fetchData();
    }
  }, [paramsState]);

  useEffect(() => {
    let mount = false;
    if (!mount) {
      init = true;
      dispatch(paramsReseted());
      getSavedFilter('LoyaltyScreen').then(() => fetchData());
    }
    props.navigation.setOptions({
      headerRight: () => {
        return isWeb ? (
          <NotificationSettingButton {...props} />
        ) : (
          <MoreButton
            menu={[
              { type: 'props', name: 'Filter', key: 'filter' },
              { type: 'props', name: 'Export Loyalty Point', key: 'export' },
            ]}
            callback={(value) => callback(value)}
          />
        );
      },
    });
    props.navigation.addListener('blur', () => {
      init = true;
    });
    return () => {
      mount = true;
      props.navigation.removeListener('blur');
    };
  }, [props.navigation]);

  return (
    <Container>
      {isWeb && (
        <SociollaText
          type="medium"
          color="#171D29"
          style={{ marginBottom: 40, fontSize: 24 }}
          // eslint-disable-next-line no-undef
          onPress={scroll}>
          Loyalty Point
        </SociollaText>
      )}
      {isWeb && (
        <SociollaTable
          name="loyalty-screen"
          table={HEADER_DEKSTOP}
          ref={tableRef}
          datas={list}
          itemComponent={renderItemDekstop}
          showSearch={true}
          showPagination={true}
          showFilter={true}
          searchPlaceholder={'Search by name...'}
          searchKey={['name']}
          count={loyalty.count}
          loading={loyalty.loading}
          customAction={
            <Button
              buttonStyle={{ ...buttonPrimary, ...buttonRounded }}
              title={
                <SociollaText
                  type="medium"
                  style={{
                    fontSize: 14,
                    color: Colors.white,
                    paddingHorizontal: 10,
                  }}>
                  Export Loyalty Point
                </SociollaText>
              }
              onPress={() => setModalExport(true)}
            />
          }
        />
      )}
      {!isWeb && (
        <SociollaTable
          name="loyalty-screen"
          table={HEADER_DEKSTOP}
          datas={list}
          itemComponent={renderItem}
          headerComponent={<></>}
          showSearch={true}
          scrollItem={true}
          showFilter={true}
          loading={loyalty.loading}
          loadingLoadMore={loyalty.loadingLoadMore}
          searchPlaceholder={'Search by name...'}
          searchKey={['name']}
        />
      )}
      {modalExport && (
        <ModalExport
          show={modalExport}
          onClose={() => setModalExport(false)}
          onSubmit={(email) => exportLoyalty(email)}
        />
      )}
    </Container>
  );
}

const styles = StyleSheet.create({
  columnRowTxt: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 20,
  },
  tableRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    height: 72,
    width: '100%',
    borderBottomColor: Colors.grey9,
    borderBottomWidth: 1,
    paddingHorizontal: 20,
  },
  tableRowDekstop: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: 64,
    width: '100%',
    borderBottomColor: Colors.grey8,
    borderBottomWidth: 1,
  },
});

export default LoyaltyScreen;
